import {cn} from '../lib/cn';
import {iconButtonVariants} from '../icon-button/iconButtonVariants';

export const calendarClassNames = {
  months: 'relative flex flex-col gap-4 sm:flex-row',
  month: 'w-full',
  month_caption: 'relative z-20 mx-10 mb-1 flex h-9 items-center justify-center',
  caption_label: 'text-sm font-medium',
  nav: 'absolute top-0 z-10 flex w-full justify-between',
  button_previous: cn(iconButtonVariants({variant: 'ghost'}), 'size-9 p-0'),
  button_next: cn(iconButtonVariants({variant: 'ghost'}), 'size-9 p-0'),
  weekday: 'size-9 p-0 text-xs font-medium text-chekin-gray-1',
  day_button: [
    'relative flex size-9 items-center justify-center whitespace-nowrap rounded-lg p-0',
    'text-[var(--calendar-day-text,var(--chekin-blue-900))] outline-offset-2',
    'group-[[data-selected]:not(.range-middle)]:[transition-property:color,background-color,border-radius,box-shadow]',
    'group-[[data-selected]:not(.range-middle)]:duration-150',
    'focus:outline-none focus-visible:z-10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-chekin-blue/70',
    'hover:bg-[var(--calendar-day-hover-bg,var(--chekin-surface-input-empty))]',
    'group-data-[selected]:bg-[var(--calendar-selected-bg,var(--chekin-blue-500))] group-data-[selected]:text-[var(--calendar-selected-text,#fff)]',
    'group-data-[disabled]:pointer-events-none group-data-[disabled]:text-chekin-gray-2 group-data-[disabled]:line-through',
    'group-data-[outside]:text-chekin-gray-2',
    'group-data-[outside]:group-data-[selected]:text-[var(--calendar-selected-text,#fff)]',
    'group-[.range-start:not(.range-end)]:rounded-e-none',
    'group-[.range-end:not(.range-start)]:rounded-s-none',
    'group-[.range-middle]:rounded-none',
    'group-data-[selected]:group-[.range-middle]:bg-[var(--calendar-range-middle-bg,var(--chekin-surface-pressed))] group-data-[selected]:group-[.range-middle]:text-[var(--calendar-range-middle-text,var(--chekin-blue-900))]',
  ].join(' '),
  day: 'group size-9 px-0 text-center text-sm',
  range_start: 'range-start',
  range_end: 'range-end',
  range_middle: 'range-middle',
  today: [
    '*:after:pointer-events-none *:after:absolute *:after:bottom-1 *:after:start-1/2',
    '*:after:z-10 *:after:size-[3px] *:after:-translate-x-1/2 *:after:rounded-full',
    '*:after:bg-[var(--calendar-today-indicator,var(--chekin-blue-500))] *:after:transition-colors',
    '[&[data-selected]:not(.range-middle)>*]:after:bg-[var(--calendar-selected-text,#fff)]',
    '[&[data-disabled]>*]:after:bg-chekin-gray-2',
  ].join(' '),
  outside:
    'text-chekin-gray-2 data-selected:bg-chekin-surface-pressed/50 data-selected:text-chekin-gray-1',
  hidden: 'invisible',
  week_number: 'size-9 p-0 text-xs font-medium text-chekin-gray-1',
};
